import { IconProps, NocIconGenerator } from '../common';

export const UndoArrow = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'UndoArrow',
            path: (
                <>
                    <path
                        d="M7.12988 18.3096H15.1299C17.8899 18.3096 20.1299 16.0696 20.1299 13.3096C20.1299 10.5496 17.8899 8.30957 15.1299 8.30957H4.12988"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.43012 10.8104L3.87012 8.25043L6.43012 5.69043"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            ),
        }}
    />
);
